import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from "vue";
import { toastGet, ToastObj } from "@plugins/toast";


export default /*#__PURE__*/_defineComponent({
  __name: 'Toast',
  setup(__props) {

const word = ref("");
const boxFlag = ref(false);
const showFlag = ref(false);

toastGet().subscribe((toastObj: ToastObj) => {
  word.value = toastObj.word;
  showFunc();
  setTimeout(
    () => {
      hideFunc();
    },
    toastObj.duration ? toastObj.duration * 1000 : 1000
  );
});

function showFunc() {
  boxFlag.value = true;
  setTimeout(() => {
    showFlag.value = true;
  });
}

function hideFunc() {
  showFlag.value = false;
  setTimeout(() => {
    boxFlag.value = false;
    word.value = "";
  }, 1000);
}

return (_ctx: any,_cache: any) => {
  return (boxFlag.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["con", { show: showFlag.value }])
      }, _toDisplayString(word.value), 3))
    : _createCommentVNode("", true)
}
}

})